import { component } from 'picoapp';

export default component(async (node) => {
    const items = node.querySelectorAll('[data-tab-anchor]')

    items.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault()

            document.dispatchEvent(
                new CustomEvent('productTabAnchorClick', {
                    detail: { hash: item.hash },
                })
            )
        })
    })
})
